import { Popover } from "antd";
import styled from "styled-components";

export const StyledPopover = styled(Popover)`
  padding: 0 !important;
  .ant-popover {
    background: #333336;
  }
  .ant-popover-arrow:before {
    background: #333336 !important;
  }
  .ant-popover-inner {
    background: #333336 !important;
  }
`;
